import { post, get } from '../util/crmAxios';
import {getBaseUrl} from "~/js/util/config";

let pre = getBaseUrl().match(/^.*-/), baseUrl;
if (pre === null) {
    baseUrl =  'http://test001-gw.myyixue.com/sales-tool/api';
} else {
    baseUrl =  'https://fuxi.songshuai.com/sales-tool/api';
}

export const getChannel = () => get('/Channel/getchannels');                             // 获取渠道列表
export const updateNodeName = objParam => post('/channel/SaveChannel', objParam);        // 更新节点名称
export const addChannelNode = objParam => post('/channel/AddChannel', objParam);         // 新增节点
export const deleteChannelNode = Id => post('/channel/RemoveChannel', {Id});             // 新增节点

// const baseUrl = 'http://192.168.0.57:8080'

// 获取渠道分类列表
export const GetChannelTypeResponses = (objParam) => get('/Channel/GetChannelTypeResponses', objParam);

// 获取渠道分类 添加/编辑分类、子分类
export const EditChannelType = (objParam) => post('/Channel/EditChannelType', objParam);

//渠道分类删除
export const DelChannelTypeById = (objParam) => post('/Channel/DelChannelTypeById', objParam);

//获取渠道分类
export const ChannelResponses = (objParam) => post('/Channel/ChannelResponses', objParam);

//渠道删除
export const DelChannel = (objParam) => post('/Channel/DelChannel', objParam);

//渠道同步
export const ChannelSync = (objParam) => post('/Channel/ChannelSync', objParam);

// 添加/编辑渠道
export const EditChannel = (objParam) => post('/Channel/EditChannel', objParam);

// 获取渠道分类级别
export const GetChannelTypeResponsesByPId = (objParam) => get('/Channel/GetChannelTypeResponsesByPId', objParam);

// 渠道批量修改
export const BatchModificateChannels = (objParam) => post('/Channel/BatchModificateChannels', objParam);

// queryTypeList
// 内容管理列表接口
export const queryFirstLevelTypePage = (params) => post(baseUrl + '/sopType/queryFirstLevelTypePage', params);
export const querySecondLevelTypeList = (params) =>post(baseUrl + '/sopType/querySecondLevelTypeList',params)
export const delSopType = params=>post(baseUrl+'/sopType/delSopType',params);
export const SopupDownType = params =>post(baseUrl+'/sopType/upDownType',params);
export const editSopType= params=>post(baseUrl+'/sopType/editSopType',params)
export const addSopType= params=>post(baseUrl+'/sopType/addSopType',params)
// export const querySuperiorTypeSelect= params=>post(baseUrl+'/sopType/querySuperiorTypeSelect',params)


// 查询 对应父级id下的分类
export const querySopTypeList= params=>get(baseUrl + '/sopType/querySopTypeList',params)

// 添加分类 / 编辑 / 添加子类
export const saveOrUpdateSopType= params=>post(baseUrl + '/sopType/saveOrUpdateSopType',params)

// 删除分类
export const deleteSopType= params=>post(baseUrl + '/sopType/deleteSopType',params)

//上升下降
export const sopTypeSort= params=>get(baseUrl + '/sopType/sopTypeSort',params)


